$(document).ready(function () {
    var windowWidth = $(window).width();

    // function initVideoControls() {
    //     let videoDesc;
    //     const video = document.getElementById('video');
    //     $("#play").click(function () {
    //         videoDesc = $(this).closest('.text-container').length > 0 ? $(this).closest('.text-container') : $(this);
    //         videoDesc.fadeOut('200');
    //         video.play();
    //         video.style.cursor = 'pointer';
    //     });
    //     video.addEventListener('ended', () => {
    //         videoDesc.fadeIn('200');
    //         video.load();
    //         video.style.cursor = 'default';
    //     });
    //     video.addEventListener('click', (e) => {
    //         video.paused ? video.play() : video.pause();
    //     });
    // }

    // if (document.getElementById('video')) {
    //     initVideoControls();
    // }



    var popup = $('#warning');
    if (popup.length > 0) {
        if (getCookie("weapon-warning") == false) {
            popup.addClass('visible');
        }
        $('#warn-agree').on('click', function () {
            popup.removeClass('visible');
            document.cookie = "weapon-warning=true;path=/";
        });
    }

    $('.popup-close').on('click', function () {
        $(this).parents(".visible").removeClass("visible");
    });

    $(".left-menu .category-menu").click(function () {
        $(".category-menu").toggleClass("closed");
        $("#shop-cat").toggleClass("none");
    });

    // Pokud chci vzpsat 2 věci jinak pro různou šířku, nejdřív musí jít nevíc omezující podínka a pak ta méně omezující.
    if (windowWidth < 1024) {
        if (windowWidth < 650) {
            initBannerPinkMobile();
            initMobileNav();
        } else {
            initMobileNav();
            initBannerPinkTablet();
        }
        initBannerCarousels();
    }
    else {
        bindNavHovers();
    }
    // init banner carousel
    initBanner();
    // checkClasses(); 


    function bindNavHovers() {
        const dropdowns = [...document.querySelectorAll('#menuElem > li')].filter(el => el.querySelector('ul'));
        dropdowns.map(el => {
            const navToBeShown = el.querySelector('ul');
            const otherOne = dropdowns.filter(drop => drop !== el)[0];
            const otherNav = otherOne.querySelector('ul');
            el.addEventListener('mouseenter', (e) => {
                navToBeShown.classList.add('show');
                navToBeShown.classList.remove('closing');
            });
            el.addEventListener('mouseleave', (e) => {
                // if going to other dropdown
                if (e.relatedTarget === otherOne) {
                    navToBeShown.classList.remove('show');
                } else {
                    navToBeShown.classList.add('closing');
                    setTimeout(() => {
                        if (navToBeShown.classList.contains('closing')) {
                            navToBeShown.classList.remove('show');
                            navToBeShown.classList.remove('closing');
                        }
                    }, 400);
                }
            });
        })

    }
    function initMobileNav() {
        $("#nav-button").click(function () {
            toggleNav();
        });

        function toggleNav() {
            $("#nav-toggle-button").toggleClass("activ");
            $("#menuElem").toggleClass("show");
            $("#lang-list").toggleClass("flex");
            $(".lang-list__item").toggle();
            $("body").toggleClass("mobile-menu");
            $(".social-mobile").toggleClass("block");
        }

        //Funkce, která mi zajistí ž eprvní potomek nebude mít odkaz
        $("#menuElem > li").filter(function (e) {
            return $(this).find('ul').length > 0;
        })
            .children("a")
            .click(function (e) {
                e.preventDefault();
            });

        // Funkce která dokáže vhyledat, zda je pod určitým elementem nějaký jiný element a určit ho
        var navElements = $("#menuElem > li").filter(function (el) {
            if ($(this).find('ul').length > 0) {
                return $(this);
            }
        });
        // Funkce, která která tomu určitému elementu dokáže přidat a oddělat class
        navElements.click(function () {
            $(this).toggleClass("open");
            var subMenu = $(this).find('ul');
            if (subMenu.hasClass('open')) {
                subMenu.removeClass('open');
                $("#menuElem").removeClass("height100");

                slideUp(subMenu[0]);
            } else {
                subMenu.addClass('open');
                $("#menuElem").addClass("height100");
                slideDown(subMenu[0]);
            }
        });

        $("#category").click(function () {
            $("#shop-cat").toggleClass("block");
        });

        if (window.innerWidth < 1024) {
            $('#menuElem > li > ul > li > a').on('click', () => {
                toggleNav();
            });
        }
    }

    function initBanner() {
        var carousel = $('.hero-bg .owl-carousel').owlCarousel({
            items: 1,
            // lazyLoad: true,
            nav: false,
            dots: false,
            mouseDrag: false,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn'         
        });
        $(".hp-static.wrapper-container.owl-carousel li").on("mouseover", function(){
            var i = $(this).index();
            carousel.trigger("to.owl.carousel", i);
        })

        var carouselHPNews = $('.hp-news-list .owl-carousel').owlCarousel({
            loop: true,
            nav: false,
            dots: false,
            mouseDrag: false,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 50,
                },
                650: {
                    items: 2,
                    stagePadding: 30
                },
                1024: {
                    items: 3,
                    stagePadding: 0,
                }
            }
        });

        var carouselPillars = $('.zone-pillars .owl-carousel').owlCarousel({
            loop: true,
            nav: false,
            dots: false,
            mouseDrag: false,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 60
                },
                350: {
                    items: 1,
                    stagePadding: 80
                },
                420: {
                    items: 1,
                    stagePadding: 100
                },
                500: {
                    items: 1,
                    stagePadding: 120
                },
                580: {
                    items: 1,
                    stagePadding: 140
                },
                640: {
                    items: 2,
                    stagePadding: 0
                },
                1024: {
                    items: 3,
                    stagePadding: 0,
                }
            }
        });


        // ES5
        // $('.hp-news-list .prev').on('click', function () {
        //     carouselHPNews.trigger('prev.owl.carousel');
        // });

        // ES6
        $('.hp-news-list .prev').on('click', () => carouselHPNews.trigger('prev.owl.carousel'));
        $('.hp-news-list .next').on('click', () => carouselHPNews.trigger('next.owl.carousel'));

        $('.zone-pillars .prev').on('click', () => carouselPillars.trigger('prev.owl.carousel'));
        $('.zone-pillars .next').on('click', () => carouselPillars.trigger('next.owl.carousel'));


    }    

    /*var ascending = false;
    $('.right-nav-menu').on('click', '#cheapest', function () {

        var sorted = $('.product .grey-box .price').sort(function (a, b) {
            return (ascending ==
                (convertToNumber($(a).find('.pink-text').html()) <
                    convertToNumber($(b).find('.pink-text').html()))) ? 1 : -1;
        });
        ascending = ascending ? false : true;

        $('.products').html(sorted);
    });*/

    /*if (windowWidth < 850) {
        initBannerMobile();
    }*/
    function initBannerPinkMobile() {
        var carouselMobil = $('.hp-info-banner .owl-carousel').owlCarousel({
            loop: true,
            items: 1,
            nav: false,
            dots: false,
            //autoplay: true,
            stagePadding: 70,
            mouseDrag: false
        });
    }

    function initBannerPinkTablet() {
        var carouselTablet = $('.hp-info-banner .owl-carousel').owlCarousel({
            loop: true,
            items: 2,
            nav: false,
            dots: false,
            //autoplay: true,
            stagePadding: 80,
            mouseDrag: false
        });
    }

    function initBannerCarousels() {
        const carouselProgram = $('.hp-static.owl-carousel').owlCarousel({
            loop: true,
            items: 1,
            nav: false,
            dots: false,
            //autoplay: true,
            stagePadding: 70,
            mouseDrag: false,
            // responsive: {
            //     0: {
            //         items: 1,
            //     }
            // }
        });

        const carouselImages = $('.hero-bg .owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn'         
        });

        carouselProgram.on('changed.owl.carousel', e => {
            let index;
            if (e.item) {
                index = e.item.index;
                var count = e.item.count;
                if (index > count) {
                    index -= count;
                }
                if (index <= 0) {
                    index += count;
                }
            }
            carouselImages.trigger('to.owl.carousel', index+2);
        });
    }



    // 3. proc se deje ta vec s lang-selectorem



    // layout of structure page
    // structureList = jquery element containing boxes
    // alignTo = jquery element from. List will be aligned to this element 
    function structureLayout(structureList, alignTo) {
        // calculate height and position of line
        var firstElemHeight = structureList.find(".structure-box").first().outerHeight();
        var lastElemHeight = structureList.children().last().outerHeight();
        var listHeight = structureList.height();

        var lineTopGap = Math.ceil(firstElemHeight / 4);
        var lineBottomGap = Math.ceil(lastElemHeight / 2);
        var lineHeight = listHeight - lineBottomGap - lineTopGap + 1;

        var line = structureList.find(".line");
        line.css({
            "top": lineTopGap + 1,
            "height": lineHeight,
        });

        // calculate top gap of list
        var alignToHeight = alignTo.outerHeight();
        var listAlignGap = Math.ceil(alignToHeight / 2);
        var prevAllHeight = 0;
        alignTo.prevAll().each(function () {
            prevAllHeight += $(this).outerHeight(true);
        });

        var listTopGap = listAlignGap + prevAllHeight - lineTopGap;
        structureList.css({
            "margin-top": listTopGap
        });
    }

    structureLayout($(".desktop .structure-list.left"), $(".structure-categories li.left"));
    structureLayout($(".desktop .structure-list.right"), $(".structure-categories li.right"));


    // vyrobni program fixed menu
    if ($(window).width() > 1024) {
        var menuWidth = $(".left-menu").width();
        $(document).scroll(function () {
            if ($(document).scrollTop() > $(".hero").height() + $(".breadcrumbs").height() - 70) {
                var menuWidth = $(".left-menu-wrapper").width();
                $(".left-menu-wrapper .left-menu").addClass("fixed");
                $(".left-menu.fixed").css({
                    "width": menuWidth
                });
            } else {
                $(".left-menu-wrapper .left-menu").removeClass("fixed");
            }
        });

        $(document).scroll(function () {
            if ($(document).scrollTop() > $("main").height() - $(".left-menu").height() - 140) {
                $(".left-menu-wrapper .left-menu").addClass("bottom");
            } else {
                $(".left-menu-wrapper .left-menu").removeClass("bottom");
            }
        });

        $(document).scroll(function () {
            if ($(document).scrollTop() > $("main").height() - $(".left-menu").height() - 140) {
                $(".left-menu-wrapp .left-menu").addClass("bottom");
            } else {
                $(".left-menu-wrapp .left-menu").removeClass("bottom");
            }
            if ($(document).scrollTop() > $(".zone-top").height() + $("header").height() - 80) {
                $(".left-menu-wrapp .left-menu").addClass("fixed");
                $(".left-menu.fixed").css({
                    "width": menuWidth
                });
            }
            else {
                $(".left-menu-wrapp .left-menu").removeClass("fixed");
            }
        });
    }


    // Pillars otvorenie po kliknuti
    $(".pillar .read-more").click(function () {
        $(this).parent().parent().addClass("open");
    });
    $(".close-button").click(function () {
        $(this).parent().removeClass("open");
    });


    // Historia zarovnanie itemov
    $(".history-item").each(function (i) {
        var oldPos = $(this).position().top;
        var gap = 16;
        var newPos = Math.ceil(oldPos / gap) * gap;
        var offset = newPos - oldPos;
        $(this).css({
            "top": offset
        });
    })

    window.sr = new ScrollReveal({
        distance: '100px',
        reset: true,
        mobile: false
    });

    var itemLeft = {
        origin: 'left'
    };

    var itemRight = {
        origin: 'right'
    }

    sr.reveal('.history-item.image-left .image', itemLeft);
    sr.reveal('.history-item.image-left .text', itemRight);

    sr.reveal('.history-item:not(.image-left) .image', itemRight);
    sr.reveal('.history-item:not(.image-left) .text', itemLeft);


    // Galeria - ukazat dalsi
    if ($(".fotogalery-wrap").length != 0) var gallery = new GalleryImage($(".fotogalery-wrap"), $(".next-fotos"));
    if ($(".machines-wrapper").length != 0) var machines = new GalleryImage($(".machines-wrapper"), $(".next-machine .pink-btn"), {
        "default": 2,
        "tablet": 2,
        "mobile": 1
    });


    // Kosik - zmazat z kosika    
    $(document).on("click", ".remove-btn", function () {
        var actualRemove = $(this).siblings(".cart-remove").find("input");
        actualRemove.click();
    });


    // Custom checkbox
    $(".checkbox input[type=checkbox]:checked").siblings("label").addClass("checked");
    $(document).on("click", ".checkbox label", function () {
        var checkbox = $(this).siblings("input[type=checkbox]");
        checkbox.checked;
        $(this).toggleClass("checked");
    });


    // filter price 
    $(document).on('click', '.btn-filter', function (e) {
        if (e.target.id === 'poverty') {
            const input = [...document.querySelectorAll('.radio--hidden input')].filter(i => i.value === 'CHEAP')[0];
            input.dispatchEvent(new MouseEvent('click'));
        } else if (e.target.id === 'poshness') {
            const input = [...document.querySelectorAll('.radio--hidden input')].filter(i => i.value === 'EXPENSIVE')[0];
            input.dispatchEvent(new MouseEvent('click'));
        }
    });

    // handle Update panel refresh and add class to .btn-filter
    Sys.WebForms.PageRequestManager.getInstance().add_endRequest(EndRequestHandler);
    function EndRequestHandler(sender, args) {
        if (args.get_error() == undefined && !args.get_response().get_aborted()) {
            if (document.querySelector('.btn-filter')) {
                const checkedInput = [...document.querySelectorAll('.radio--hidden input')].filter(i => i.getAttribute('checked') === 'checked');
                if (checkedInput.length > 0) {
                    if (checkedInput[0].value === 'CHEAP') {
                        $('#poverty').addClass('active');
                    } else if (checkedInput[0].value === 'EXPENSIVE') {
                        $('#poshness').addClass('active');
                    }
                }
            }
        }
    }

    // Number input
    $(document).on("click", ".custom-number-input .number-input .number-controls span", function () {
        var container = $(this).parent().parent();
        var input = container.find("input");
        var value = parseInt(input.val());
        var toggle = container.siblings(".UnitCountButton").find("input[type=submit]");
        if ($(this).hasClass("add")) input.val(value + 1);
        if (value > 1 && $(this).hasClass("remove")) input.val(value - 1);
        toggle.click();

    });

    //E-shop add items conatiner
    $(document).on("click", ".e-shop-detail .custom-number-input .number-input .number-controls span", function () {
        var container = $(".AddToCartContainer");
        var input = container.find(".AddToCartTextBox");
        var value = parseInt(input.val());
        if ($(this).hasClass("add")) input.val(value + 1);
        if (value > 1 && $(this).hasClass("remove")) input.val(value - 1);
    });

    $(".place-order .form label").each(function () {
        var label = $(this);
        var text = $(label).text().replace(":", " ");
        label.text(text);
    })

    const formControls = $(".place-order .form input.form-control");

    formControls.each(function () {
        if ($(this).val() !== '') {
            $(this).closest('.form-group').addClass('noempty');
        }
    });

    $(".place-order .form input.form-control").on('focus', function () {
        var parent = $(this).closest(".form-group");
        parent.addClass("noempty");
    })

    $(".place-order .form input.form-control").on('blur', function () {
        var parent = $(this).closest(".form-group");
        if ($(this).val() == "") {
            parent.removeClass("noempty");
        }
    });

    // disable dektop dropdown links 
    if (window.innerWidth > 1024) {
        $('li.program > a, li.company > a').on('click', e => e.preventDefault());
    }

    $("#home-down").click(function () {
        $('html, body').animate({
            scrollTop: $(".hp-info-banner").offset().top - 184
        }, 1000);
    });
});


function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}